var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHandle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 22,
  viewBox: "0 0 35 22",
  fill: "none",
  style: {
    verticalAlign: "middle"
  }
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.60794 13.0597C-0.198093 12.532 -0.198087 9.97357 1.60795 9.4459L31.6148 0.678779C32.8198 0.326727 34.0252 1.23036 34.0252 2.48569V20.0199C34.0252 21.2753 32.8198 22.1789 31.6148 21.8268L1.60794 13.0597Z",
  fill: "white"
})));
export default SvgHandle;